// import { IconProps } from './IconProps';

export const HomeIcon = ({
  className,
  style,
  fill = 'black',
  width = 14,
  height = 14,
}: {
  className?: string;
  style?: Record<string, unknown>;
  fill?: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      className={className}
      style={style}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.4683 9.52471H4.1907C4.21413 9.52471 4.23619 9.53286 4.25273 9.5479C4.26927 9.56295 4.27892 9.58364 4.27892 9.60496V13.2398C4.27892 13.2611 4.26927 13.2812 4.25273 13.2962C4.23619 13.3113 4.21413 13.3201 4.1907 13.3201H2.4683C2.42005 13.3201 2.38008 13.2843 2.38008 13.2398V9.60303C2.38008 9.55852 2.42005 9.52278 2.4683 9.52278V9.52471ZM8.69486 7.91978H10.4173C10.4407 7.91978 10.4634 7.92793 10.48 7.94297C10.4965 7.95802 10.5055 7.97871 10.5055 8.00002V13.2398C10.5055 13.2611 10.4965 13.2812 10.48 13.2962C10.4634 13.3113 10.4407 13.3201 10.4173 13.3201H8.69554C8.64661 13.3201 8.60732 13.2843 8.60732 13.2398V7.9981C8.60732 7.95359 8.64661 7.91785 8.69554 7.91785L8.69486 7.91978ZM5.5822 4.70991H7.3046C7.32803 4.70991 7.35077 4.71806 7.36732 4.73311C7.38386 4.74815 7.39282 4.76884 7.39282 4.79016V13.2398C7.39282 13.2611 7.38386 13.2812 7.36732 13.2962C7.35077 13.3113 7.32803 13.3201 7.3046 13.3201H5.58288C5.53395 13.3201 5.49466 13.2843 5.49466 13.2398V4.78823C5.49466 4.74372 5.53395 4.70798 5.58288 4.70798L5.5822 4.70991ZM0.308089 14.5H0.308778C0.138537 14.5 0 14.374 0 14.2191C0 14.0637 0.138537 13.9383 0.308778 13.9383H15.6912C15.8615 13.9383 16 14.0637 16 14.2191C16 14.374 15.8615 14.5 15.6912 14.5H0.308089ZM11.8088 1.50004H13.5318C13.5553 1.50004 13.5773 1.5082 13.5939 1.52324C13.6104 1.53829 13.6201 1.55898 13.6201 1.58029V13.2398C13.6201 13.2611 13.6104 13.2812 13.5939 13.2962C13.5773 13.3113 13.5553 13.3201 13.5318 13.3201H11.8094C11.7605 13.3201 11.7212 13.2843 11.7212 13.2398V1.57837C11.7219 1.53448 11.7612 1.5 11.8094 1.5L11.8088 1.50004Z"
        fill={fill}
      />
    </svg>
  );
};
